import { render, staticRenderFns } from "./ChurnReasonManager.vue?vue&type=template&id=67e58b0b&scoped=true&"
import script from "./ChurnReasonManager.vue?vue&type=script&lang=js&"
export * from "./ChurnReasonManager.vue?vue&type=script&lang=js&"
import style0 from "./ChurnReasonManager.vue?vue&type=style&index=0&id=67e58b0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e58b0b",
  null
  
)

export default component.exports